import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { ReclamationActionDetailCodes, ReclamationActionDetailType } from 'constants.js';
import stringHelper from 'utils/stringHelper';

import TextField from '@mui/material/TextField';
import DialogContent from '@mui/material/DialogContent';

import DropZone from 'components/Shared/DropZone';

import { CategorieCodes } from 'constants.js';
import { QualificationCodes } from 'constants.js';
import { CausePrincipaleCodes } from 'constants.js';
import { MotifResolutionCodes } from 'constants.js';

const styles = theme => ({
    formControl: {
        width: '100%'
    },

    detailValue: {
        paddingLeft: theme.spacing(4)
    }
});



const defaultMemo = `Cher client,\n\nSuite à votre demande de retour de marchandise(s) livré conforme.\nLe transporteur enlèvera le(s) colis à partir du \n\n`;

class PrevenirClientRepriseMarchandiseDialogContent extends React.Component {
    
    constructor(props) {
        super(props);

        let memo = defaultMemo;

        if (this.props.contenuMail) {
            memo = this.props.contenuMail
        }

        this.state = {
            commentaire: memo,
            fichiersIds: []
        };
    }

    componentDidMount() {
        const { categorieCode, qualificationCode } = this.props;

        const actionData = this.getActionData(this.state);

        let clotureData = null;
        // Si changement d'adresse, cloture automatique
        if (categorieCode === CategorieCodes.ErreurAdresseLivraison && qualificationCode === QualificationCodes.ChangementAdresse) {
            clotureData = {
                motifResolutionCode: MotifResolutionCodes.ChangementAdresseLivraison,
                causePrincipaleCode: CausePrincipaleCodes.DemandeEnlevement,
                causePrincipaleDetailId: 0,
                utilisateurFautifId: 0,
                commentaire: '',
                mailAutomatique: ''
            };
        }

        this.props.onChange(actionData, clotureData);
    }

    getActionData(newState) {
        const { action } = this.props;
        

        if (stringHelper.isNullOrWhitespace(newState.commentaire)) {
            return null;
        }

        if (newState.commentaire === defaultMemo) {
            return null;
        }

        let actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.Memo,
                type: ReclamationActionDetailType.Texte,
                libelle: "Mémo :",
                position: 0,
                valeurString: newState.commentaire
            }],
            reponseAttendue: false
        };

        if (newState.fichiersIds.length > 0) {
            actionData.fichiersIds = newState.fichiersIds;
        }

        return actionData;
    }

    handleChange = (event) => {
        const { categorieCode, qualificationCode } = this.props;
         
        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);

        let actionData = this.getActionData(newState);


        let clotureData = null;
        // Si changement d'adresse, cloture automatique
        if (categorieCode === CategorieCodes.ErreurAdresseLivraison && qualificationCode === QualificationCodes.ChangementAdresse) {
            clotureData = {
                motifResolutionCode: MotifResolutionCodes.ChangementAdresseLivraison,
                causePrincipaleCode: CausePrincipaleCodes.DemandeEnlevement,
                causePrincipaleDetailId: 0,
                utilisateurFautifId: 0,
                commentaire: '',
                mailAutomatique: ''
            };
        }

        this.props.onChange(actionData, clotureData);

    }

    render() {
        const { classes } = this.props;
        const { commentaire } = this.state;

        return (
            <DialogContent>
                
                <TextField className={classes.formControl}
                    id="commentaire"
                    name="commentaire"
                    label="Commentaire"
                    placeholder="Commentaire"
                    multiline
                    margin="normal"
                    value={commentaire}
                    onChange={this.handleChange}
                />
                <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
            </DialogContent>
        );
    }
}

PrevenirClientRepriseMarchandiseDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

export default withStyles(styles)(PrevenirClientRepriseMarchandiseDialogContent);